import { useNavigate } from "react-router-dom";
import { CalendarDays, ChevronLeft, AlertCircle, FileCode } from "lucide-react";

/**
 * Season Tickets Page - NOT CONNECTED YET
 * Shell component showing required API endpoint
 */
export default function CommercialSeasonTickets() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50" data-testid="commercial-season-tickets">
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate("/admin/commercial")} className="p-2 hover:bg-gray-100 rounded-lg"><ChevronLeft className="w-5 h-5" /></button>
          <div><h1 className="text-xl font-bold text-gray-900">Season Tickets</h1><p className="text-sm text-gray-500">Long-term parking permits</p></div>
        </div>
      </div>

      <div className="p-6">
        <div className="max-w-2xl mx-auto">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-8 h-8 text-amber-600" />
            </div>
            <h2 className="text-xl font-bold text-amber-800 mb-2">Not Connected Yet</h2>
            <p className="text-amber-700 mb-6">The Season Tickets API has not been implemented yet.</p>
            
            <div className="bg-white rounded-lg p-4 text-left border border-amber-200">
              <div className="flex items-center gap-2 mb-3">
                <FileCode className="w-5 h-5 text-amber-600" />
                <span className="font-semibold text-amber-800">Required Endpoint</span>
              </div>
              <code className="block bg-gray-100 p-3 rounded text-sm text-gray-700 font-mono">
                GET /api/commercial/season-tickets
              </code>
              <p className="mt-3 text-sm text-gray-600">
                This endpoint should return season ticket records with fields:
              </p>
              <ul className="mt-2 text-sm text-gray-600 list-disc list-inside space-y-1">
                <li>ticket_id, holder_name, reg_number</li>
                <li>site_id, start_date, end_date</li>
                <li>amount_pence, status</li>
                <li>payment_schedule (monthly/quarterly/annual)</li>
                <li>auto_renew, created_at</li>
              </ul>
            </div>

            <div className="mt-6 flex items-center justify-center gap-4">
              <button onClick={() => navigate("/admin/commercial")} className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-white">
                Back to Dashboard
              </button>
              <button onClick={() => navigate("/admin/commercial/resident-passes")} className="px-4 py-2 text-sm bg-amber-600 text-white rounded-lg hover:bg-amber-700">
                View Resident Passes Instead
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
